import { Component, OnInit, ViewChild, Input, AfterViewInit } from "@angular/core";
import { ServiceAgent } from 'src/app/framework-modules/formdata/form/serviceAgent';
import { GroupPanel } from '../../interfaces';
import { SessionComponent } from '../../component';
import { CtEditableTableComponent } from 'src/app/framework-modules/elements/ct-editable-table/component';
import { ConsolidatedAttendanceForm, ConsolidatedAttendanceFd, ConsolidatedAttendanceVo } from 'src/app/framework-modules/formdata/gen/consolidatedAttendanceForm';
import { MessageService } from 'src/app/services/messageService';
import { MatDialog } from '@angular/material';
import { CtDialogComponent } from 'src/app/framework-modules/elements/ct-dialog/component';
import { TableMetaData } from 'src/app/framework-modules/elements/ct-table/component';
import { Vo } from 'src/app/framework-modules/formdata/form/types';
import * as _ from 'lodash';
import { ExcelParserService } from "src/app/services/excelParserService";
import { ExcelDownloadService, ExcelTemplate } from "src/app/services/excelDownloadService";
import { ClientContext } from 'src/app/framework-modules/formdata/form/clientContext';

@Component({
  selector: "consolidated-attendance-list",
  templateUrl: "./component.html",
  styleUrls: ["./component.scss"]
})

export class ConsolidatedAttendanceEditComponent implements OnInit, AfterViewInit {
  @ViewChild("gridTable", { static: false }) gtable: CtEditableTableComponent;
  @Input() inputData: any;
  @Input() parentPanel: GroupPanel;
  @Input() session: SessionComponent;

  headerForm: ConsolidatedAttendanceForm;
  headerData: ConsolidatedAttendanceFd;
  headerVo: ConsolidatedAttendanceVo = {};
  fullscreen: boolean = false;

  public tableData: TableMetaData;
  totalClasses: number;
  ;

  constructor(private sa: ServiceAgent, private ms: MessageService, private dialog: MatDialog, private ep: ExcelParserService, private ds: ExcelDownloadService,private cc:ClientContext) {
    this.headerForm = ConsolidatedAttendanceForm.getInstance();
    this.headerData = this.headerForm.newFormData(this.sa);
  }

  metaDataInit() {
    this.tableData = {
      data: [],
      metaData: {
        column_names: [
          "name",
          "usn",
          "totalClasses",
          "totalAttendance"
        ],
        display_names: {
          "name": "Student Name",
          "usn": "USN",
          "totalClasses": "Total Classes",
          "totalAttendance": "Classes Attended"
        },
        editable_columns: [
          "totalClasses",
          "totalAttendance"
        ],
        validations: {
          "totalClasses": {
            minValue: 0,
            pattern: '^[0-9]+$'
          },
          "totalAttendance": {
            minValue: 0,
            pattern: '^[0-9]+$'
          }
        },
        error: "Error",
        search:true,
        placeholder:'Search by Student Name, USN....',
      }
    };
  }

  ngOnInit() {
    this.metaDataInit();
    this.getData(this.inputData);
  }

  ngAfterViewInit() {
    this.gtable.update();
  }

  getData(sectionId: any) {
    console.log('Edit pge started for section id ' + sectionId);
    this.headerData.setFieldValue('subjectSectionId', sectionId);

    this.headerData.fetchData().subscribe(
      data => {
        this.headerVo = data;
        this.tableData.data = data.students as Vo[];
        var counts = {};
        this.tableData.data.forEach(function(row) { counts[row.totalClasses as any] = (counts[row.totalClasses as any] || 0)+1; });
        this.totalClasses =  _.invert(counts)[Math.max(Object.values(counts) as any)];
        this.headerData.setFieldValue('totalClasses', this.totalClasses);
        this.gtable.update();
      },
      msgs => {
        console.error(msgs);
      }
    );
  }

  save() {
    if(!this.validate()){
      return;
    }
    this.headerData.save().subscribe(
      data =>{
        this.ms.showSuccess("Attendance updated Successfully!");
        this.parentPanel.navigate('ConsolidatedAttendanceList')
      },
      msgs =>{
        console.log(msgs);
      }
    );
  }

  validate() :boolean {
    var flag = true;
    (this.headerData.getRawData().students as {}[]).forEach(row => {
      if(parseInt(row["totalClasses"]) < parseInt(row["totalAttendance"])){
        this.ms.showError("Student "+ row["usn"] + " has attended classes more that total classes.");
        flag = false;
      }
    })
    return flag;
  }

  cancel() {
    let dialogRef = this.dialog.open(CtDialogComponent);
    dialogRef.componentInstance.title = 'Discard Changes';
    dialogRef.componentInstance.content = 'Are you sure you want to discard changes?';
    dialogRef.componentInstance.primary = 'Discard';
    const subscribeDialog = dialogRef.componentInstance.save.subscribe((data) => {
      this.dialog.closeAll();
      this.parentPanel.navigate('ConsolidatedAttendanceList')
    });
  }

  goFullscreen(){
    this.fullscreen = !this.fullscreen;
  }

  setTotalClasses($event){
    this.tableData.data.forEach(row =>{
      if(row.totalClasses == this.totalClasses){
        row.totalClasses = $event;
      }
    });
    this.gtable.update();
    this.totalClasses = $event;
  }

  popUpMessage(){
    let dialogRef = this.dialog.open(CtDialogComponent);
    dialogRef.componentInstance.title = 'NOTICE';
    dialogRef.componentInstance.content = 'Kindly modify the attendance column(s) only. If you find any mismatch in data, contact your system administrator.';
    dialogRef.componentInstance.primary = 'Download Template';
    const subscribeDialog = dialogRef.componentInstance.save.subscribe((data) => {
      // Yet to implement bulk upload functionality
      this.dialog.closeAll();
      this.downloadTemplate()
    });
  }

  downloadTemplate(){
    let templateData = [];
    let template: ExcelTemplate = {
      fixedHeader: [
        { loc: "A1", value: `${this.cc.getinstituteName()}, ${this.cc.getinstituteCity()} - ${this.cc.getinstitutePinCode().split(' ')[this.cc.getinstitutePinCode().split(' ').length-1]}`.toUpperCase(), style: { font: { size: 18, name: 'Cambria', bold: true }, alignment: { horizontal: 'center', vertical: 'middle' }, border: {}, fill: null, numFmt: '', protection: {locked:true} } },
        { loc: "A2", value: `(Autonomous Institute, Affiliated to ${this.cc.getuniversityName()})`, style: { font: { size: 12, name: 'Cambria', bold: true }, alignment: { horizontal: 'center', vertical: 'middle' }, border: {}, fill: null, numFmt: '', protection: {locked:true} } },
        { loc: "A3", value: "Attendance Upload --- "+this.headerVo.subjectName+" - "+ this.headerVo.subjectCode +" - "+this.headerVo.sectionName, style: { font: { size: 16, name: 'Cambria', bold: true }, alignment: { horizontal: 'center', vertical: 'middle' }, border: {}, fill: null, numFmt: '', protection: {locked:true} } },
      ],
      dynamicHeader: [],
      merges: ['A1:D1', 'A2:D2', 'A3:D3'],
      tableArray: "students",
      tableStart: 5,
      tableStyle: { rowHeight: 15, },
      tableHeader: ["USN", "Name", "Total Classes", "Total Attendance"],
      tableValues: [
        { key: "usn", width: 35, style: { font: { size: 12, name: 'Cambria' }, alignment: { horizontal: 'center', vertical: 'middle' }, border: {}, fill: null, numFmt: '', protection: {locked:true} } },
        { key: "name", width: 65, style: { font: { size: 12, name: 'Cambria' }, alignment: { horizontal: 'left', vertical: 'middle' }, border: {}, fill: null, numFmt: '', protection: {locked:true} } },
        { key: "totalClasses", width: 10, style: { font: { size: 12, name: 'Cambria' }, alignment: { horizontal: 'center', vertical: 'middle' }, border: {}, fill: null, numFmt: '', protection: null } },
        { key: "totalAttendance", width: 10, style: { font: { size: 12, name: 'Cambria' }, alignment: { horizontal: 'center', vertical: 'middle' }, border: {}, fill: null, numFmt: '', protection: null } },  
      ],
      colWidths: [30, 60,20,20],
      fixedFooter: [],
      dynamicFootfer: [],
      footerMerges: [],
      footerRowHeights: [],
      tableHeaderStyle: { font: { size: 14, name: 'Cambria', bold: true }, alignment: { horizontal: 'center', vertical: 'middle' }, border: {bottom: {style: 'thin'},top: {style: 'thin'}, left: {style: 'thin'},right:{style: 'thin'} }, fill: {type: 'pattern',pattern: 'solid',fgColor: {  argb: 'FF00FF00'}}, numFmt: '', protection: {locked:true} }
    }
    this.ds.excelFromTemplate(template,{"students":this.tableData.data},"Attendance Template --- "+this.headerVo.subjectCode+"-"+this.headerVo.sectionName,this.headerVo.sectionName)
  }

  onFileChange(ev){
    this.ep.parseAttendance(ev,this.headerVo.sectionName).subscribe(
      data =>{
        this.fillData(data);
      }
    );
  }

  /**
   * usnMap = {usn:index};
   * @param data has {usn:{total:xx,attended:yy}}
   */
  private fillData(data:{}){
    var usnMap = {};
    this.tableData.data.forEach((element,index) =>{
      usnMap[element["usn"] as string] = index;
    });
    if(Object.keys(data).length != Object.keys(usnMap).length){
      this.ms.showError("Number of students is not same in excel and in database. Excel data manipulated!");
      return;
    }
    let flag: boolean = true;
    Object.keys(data).forEach(key =>{
      let index = usnMap[key];
      if(index == undefined){
        this.ms.showError(key+" not found in this section. Excel Data manipulated");
        flag=false;
        return;
      }
    });
    if(flag){
      Object.keys(data).forEach(key =>{
        let index = usnMap[key];
        this.tableData.data[index]["totalClasses"] = data[key]['total'];
        this.tableData.data[index]["totalAttendance"] = data[key]['attended'];
      });
      this.ms.showSuccess("Excel Uploaded Successfully!");
    }
  }
}